export default class LifeMortgageClause {
  public riskNumber?: number = 1
  public loanNumber: string
  public expirationDate: string
  public entity: string

  constructor(data: LifeMortgageClause) {
    this.loanNumber = data.loanNumber
    this.expirationDate = data.expirationDate
    this.entity = data.entity
  }
}
